/**
 * Utility functions for Google Tag Manager and analytics
 */

/**
 * Push an event to the GTM dataLayer
 * @param eventName - Name of the event
 * @param eventData - Additional data to send with the event
 */
export const pushGTMEvent = (eventName: string, eventData: Record<string, any> = {}) => {
  // Make sure dataLayer exists
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    
    // Push the event to the dataLayer
    window.dataLayer.push({
      event: eventName,
      ...eventData
    });
  }
};

/**
 * Track a form panel view
 * @param panelId - ID of the panel being viewed
 */
export const trackPanelView = (panelId: string) => {
  pushGTMEvent('lead_form_panel_load', {
    panel_name: panelId
  });
};

// Add TypeScript interface for window.dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
} 